import type { ReactNode } from 'react';

/**
 * The display-rung H1 of the six auth pages (#3169). Login, magic link, MFA,
 * reset, set-new and forgot-password render inside `AuthShell`, not the app
 * shell, so there is no `PageHead` to carry the display rung for them. The
 * heading recipe was copied thirteen times across those pages; this is the one
 * place that spells it now.
 *
 * `size="sm"` is the 44px ceiling the sign-in form's own heading uses, where
 * the form sits beside the heading; every other auth state opens at 48px.
 *
 * Each size is ONE literal on purpose: the serif guard in
 * `grammar-guards.test.ts` reads the string window around each `font-serif`,
 * and the display-rung exemption for this file matches the 48px clamp there.
 */
const AUTH_HEADING_CLASS = {
  lg: 'font-serif text-[clamp(34px,4.4vw,48px)] font-normal leading-[1.08] tracking-[-0.018em] text-stevens-ink m-0 text-balance',
  sm: 'font-serif text-[clamp(34px,4.4vw,44px)] font-normal leading-[1.08] tracking-[-0.018em] text-stevens-ink m-0 text-balance',
} as const;

export type AuthHeadingSize = keyof typeof AUTH_HEADING_CLASS;

export function AuthHeading({ size = 'lg', children }: { size?: AuthHeadingSize; children: ReactNode }) {
  return <h1 className={AUTH_HEADING_CLASS[size]}>{children}</h1>;
}
